import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SustainabilityMetrics } from '@/models/sustainability';
import { ui } from '@/constants';

const currentYear = new Date().getFullYear();

@Component({
  name: 'CmgSustainabilityStatsPage',
})
export default class CmgSustainabilityStatsPage extends Vue {
  isLoading = false;
  didError = false;

  @Watch('isLoggedIn', {immediate: true})
  onLogin(onLoginStatusChange: boolean) {
    if (this.isLoggedIn && !this.sustainabilityHistoryMetrics) {
      this.fetchOrderHistory();
    }
  }

  get isLoggedIn(): boolean | undefined {
    return this.$services.customer.isLoggedIn();
  }

  get foodprintDoodles(): string {
    return this.isMobile
      ? this.$appStore.state.cms.images.backgrounds.foodprintDoodlesAccountMobile.default
      : this.$appStore.state.cms.images.backgrounds.foodprintDoodlesAccountDestkop.default;
  }

  get sustainabilityHistoryMetrics(): SustainabilityMetrics | null {
    const history = this.$appStore.state.customer.sustainabilityMetrics.history;
    return history ? (history.numOfOrders ? history : null) : null;
  }

  get currentYear(): number {
    return currentYear;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth < ui.breakpoints.tablet;
  }

  // Only show the the "metrics unavailable" view if any one of these conditions are true
  get metricsUnavailable(): boolean {
    return this.didError || !this.isLoggedIn || !this.sustainabilityHistoryMetrics;
  }

  onSignInButtonClick() {
    this.$services.ui.setModalVisibility('signIn', true);
  }

  async fetchOrderHistory() {
    this.isLoading = true;
    this.didError = false;

    try {
      await this.$services.sustainability.getHistorySustainabilityMetrics();
    } catch (_) {
      this.didError = true;
    } finally {
      this.isLoading = false;
    }
  }
}
